"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomestikaLiveSpinner = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _Layout = require("../Layout");

var _DomestikaLive = require("./DomestikaLive");

var _Icon = require("../Icon");

var _Icons = require("../Icons");

function rotationEffect() {
  return (0, _styledComponents.keyframes)(["from{transform:rotate(0deg);}to{transform:rotate(359deg);}"]);
}

var StyledDomestikaLiveSpinner = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "DomestikaLiveSpinner__StyledDomestikaLiveSpinner",
  componentId: "sc-1b3iou7-0"
})(["", " display:grid;place-items:center;"], _styledSystem.layout);
var StyledDomestikaIcon = (0, _styledComponents.default)(_Icon.IconForm).withConfig({
  displayName: "DomestikaLiveSpinner__StyledDomestikaIcon",
  componentId: "sc-1b3iou7-1"
})(["grid-column:1/1;grid-row:1/1;"]);
var StyledDomestikaLive = (0, _styledComponents.default)(_DomestikaLive.DomestikaLive).withConfig({
  displayName: "DomestikaLiveSpinner__StyledDomestikaLive",
  componentId: "sc-1b3iou7-2"
})(["grid-column:1/1;grid-row:1/1;animation:", " 44s infinite linear;"], rotationEffect);

var DomestikaLiveSpinner = function DomestikaLiveSpinner(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return _react.default.createElement(StyledDomestikaLiveSpinner, {
    width: width,
    height: height
  }, _react.default.createElement(StyledDomestikaIcon, {
    color: color,
    size: "huge"
  }, _react.default.createElement(_Icons.TildeSolid, null)), _react.default.createElement(StyledDomestikaLive, {
    width: width,
    height: height,
    color: color
  }));
};

exports.DomestikaLiveSpinner = DomestikaLiveSpinner;
DomestikaLiveSpinner.defaultProps = {
  width: '137px',
  height: '140px',
  color: 'coco'
};